import { ChangeDetectorRef, Component, Injector, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormGenerico } from '../formgenerico/formgenerico';
import { FatorMoeda } from 'src/app/model/geral/fatorMoeda';

@Component({
  selector: 'app-form-adiantamento-generico',
  templateUrl: './formadiantamentogenerico.component.html',
})
export class FormAdiantamentoGenericoComponent extends FormGenerico<any> implements OnInit {

  mode: 'inline' | 'detail' = 'inline';
  objSel: any = {};
  salvando = false;

  // Fields for editing
  totalAdiantam: number = 0;
  totalAdiantamMoeda: number = 0;
  obs: string = '';
  fatorMoeda: any = null;

  // Detail mode specific
  detailObj: any = {};
  detailService: any = null;

  // Configuration from caller
  totalField = 'totalAdiantam';
  totalMoedaField = 'totalAdiantamMoeda';
  obsField = 'obs';
  regraId = 628;

  constructor(
    injectorObj: Injector,
    public refDialog: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private cdRef: ChangeDetectorRef
  ) {
    super(injectorObj, config.data.apiService);
  }

  override ngOnInit(): void {
    if (!this.config.data?.objSel) {
      this.refDialog.close();
      return;
    }

    this.objSel = this.config.data.objSel;
    this.mode = this.config.data.mode || 'inline';
    this.regraId = this.config.data.regraId || 628;

    // Dynamically instantiate the class and query its field configuration from the database metadata
    const className = this.config.data.className || 
                      (this.objSel.idTab === 325 || this.objSel.numTitulo !== undefined ? 'Movimento' : 'OrdemServico');
    this.obj = this.getClassInstance(className, null);
    this.findTable();

    if (this.mode === 'inline') {
      this.totalField = this.config.data.totalField || 'totalAdiantam';
      this.totalMoedaField = this.config.data.totalMoedaField || 'totalAdiantamMoeda';
      this.obsField = this.config.data.obsField || 'obs';

      this.totalAdiantam = this.objSel[this.totalField] || 0;
      this.totalAdiantamMoeda = this.objSel[this.totalMoedaField] || 0;
      this.obs = this.objSel[this.obsField] || '';
      this.fatorMoeda = this.objSel.fatorMoeda ? { ...this.objSel.fatorMoeda } : null;
    } else {
      // detail mode (e.g. OS)
      this.detailService = this.config.data.detailService;
      if (this.config.data.detailObj) {
        this.detailObj = { ...this.config.data.detailObj };
        this.totalAdiantam = this.detailObj.valor || 0;
        this.totalAdiantamMoeda = this.detailObj.valorMoeda || 0;
        this.obs = this.detailObj.obs || '';
        this.fatorMoeda = this.detailObj.fatorMoeda ? { ...this.detailObj.fatorMoeda } : null;
      } else {
        this.detailObj = {};
        this.totalAdiantam = 0;
        this.totalAdiantamMoeda = 0;
        this.obs = '';
        if (this.objSel.fatorMoeda) {
          this.fatorMoeda = { ...this.objSel.fatorMoeda };
        }
      }
    }

    // Resolve the full FatorMoeda if only ID is present to ensure all fields are filled
    if (this.fatorMoeda?.id && (!this.fatorMoeda.fator || !this.fatorMoeda.moeda)) {
      const fmoService = this.globalFunctions.returnApi('FatorMoeda');
      if (fmoService) {
        fmoService.findById(this.auth.empresa.id, this.fatorMoeda.id).subscribe({
          next: (res: any) => {
            this.fatorMoeda = res;
          }
        });
      }
    }
  }

  getSysCampo(nomeProp: string): any {
    return (this.listSysFields || []).find(c => c.nomeProp === nomeProp);
  }

  // ─── Bidirectional conversion calculations ─────────────────────────────────

  onValorMoedaChange(): void {
    const fator = this.getFator();
    this.totalAdiantam = parseFloat(((this.totalAdiantamMoeda || 0) * fator).toFixed(2));
  }

  onValorBrlChange(): void {
    const fator = this.getFator();
    this.totalAdiantamMoeda = parseFloat(((this.totalAdiantam || 0) / (fator || 1)).toFixed(4));
  }

  getFator(): number {
    return this.fatorMoeda?.fator || 1;
  }

  atualizarFatorMoeda(sel: any): void {
    this.fatorMoeda = sel;
    if (this.mode === 'detail') {
      this.detailObj.fatorMoeda = sel;
    }
    this.onValorMoedaChange();
  }

  confirmar(): void {
    if (this.salvando) return;
    this.salvando = true;

    if (this.mode === 'inline') {
      const fieldsToSave: any = {
        [this.totalField]: String(this.totalAdiantam),
        [this.totalMoedaField]: String(this.totalAdiantamMoeda),
        [this.obsField]: this.obs || '',
        'fatorMoeda': this.fatorMoeda?.id ? String(this.fatorMoeda.id) : ''
      };

      this.api.updateParcialMult(this.auth.empresa.id, this.objSel.id, fieldsToSave, this.regraId).subscribe({
        next: () => {
          this.messageService.add({
            severity: 'success',
            summary: this.translocoService.translate('mens_sucess') || 'Sucesso',
            detail: this.translocoService.translate('mens_update_save') || 'Registro salvo com sucesso.'
          });
          this.refDialog.close(true);
        },
        error: err => {
          this.salvando = false;
          this.errorHandler.handle(err);
        }
      });
    } else {
      // detail mode
      const payload: any = {
        id: this.detailObj.id || null,
        ordemServico: { id: this.objSel.id },
        fatorMoeda: this.fatorMoeda?.id ? { id: this.fatorMoeda.id } : null,
        valor: this.totalAdiantam || 0,
        valorMoeda: this.totalAdiantamMoeda || 0,
        obs: this.obs || '',
        empresaCad: this.auth.empresa.id
      };

      const op$ = this.detailObj.id
        ? this.detailService.updateAdiant(this.detailObj.id, payload)
        : this.detailService.insertAdiant(payload);

      op$.toPromise()
        .then(() => {
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Adiantamento salvo com sucesso.'
          });
          this.refDialog.close(true);
        })
        .catch(err => {
          this.salvando = false;
          this.errorHandler.handle(err);
        });
    }
  }

  sair(): void {
    this.refDialog.close(false);
  }

  override dataExtraObj(res: any): void {}
  protected override onPropertyChange(propName: string, newValue: any): void {}
}
